module.exports = __webpack_public_path__ + "static/img/banner.46e90fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/site/programme_resource_management/banner.jpg
// module id = r9jC
// module chunks = 0